
// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ブログサムネイル 中心でトリミング // Blog thumbnail Crop at center
jQuery(function($) {
    if ( $('.obj_image').length > 0 ) {
        objectFitImages('.obj_image');
    }
});



// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

// 追従サイドバー
jQuery(function ($) {
	var $sidebar = $('.p-lowerCont__side');
  if($sidebar.length){
	var $container = $('.p-lowerCont__main');
	var sidebarStartOffset = $sidebar.offset().top; // 初期の位置
	var containerBottom = $container.offset().top + $container.outerHeight();
	var $sidebarHeight = $sidebar.outerHeight();
	var offset = 100;

		$(window).scroll(function () {
			if (window.innerWidth >= 769) {
				var scrollTop = $(window).scrollTop();

				if (scrollTop + offset >= sidebarStartOffset && scrollTop + offset + $sidebarHeight <= containerBottom) {
					$sidebar.css({
						position: 'fixed',
						top: offset+'px'
					});
					$sidebar.fadeIn();
				} else if (scrollTop + offset + $sidebarHeight > containerBottom) {
					$sidebar.fadeOut();
				} else {
					$sidebar.css({
						position: 'absolute',
						top: offset+'px'
					});
					$sidebar.fadeIn();
				}
			}
	});
  }
});

jQuery(document).ready(function ($) {
  // スクロール位置を監視
	$(window).on('scroll', function () {
		if (window.innerWidth >= 769) {
			var scrollPos = $(window).scrollTop(); // 現在のスクロール位置

			$('.p-lowerCont__main>section').each(function () {
				var sectionOffset = $(this).offset().top; // セクションの上端位置
				var sectionHeight = $(this).outerHeight();
				var sectionId = $(this).attr('id');

				// セクションが表示領域内に入ったら
				if (scrollPos >= sectionOffset - 150 && scrollPos < sectionOffset + sectionHeight) {
					$('.p-lowerCont__side a').removeClass('active'); // 他のリンクからactiveを削除
					$('.p-lowerCont__side a[href="#' + sectionId + '"]').addClass('active'); // 現在のリンクにactiveを追加
				}
			});
		}
  });
});


const select = document.getElementById("orderSelect");

if (select) {
  const currentUrl = location.href;

  for (let opt of select.options) {
    if (currentUrl.startsWith(opt.value)) {
      opt.selected = true;
      break;
    }
  }
}


jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});


//SVG挿入
jQuery('.js-svg').each(function () {
	let $ = jQuery
    const src = $(this).data('src');
    fetch(src)
        .then((res) => res.text())
        .then((svg) => {
            $(this).append(svg);
        });
});
